export async function pipeAsyncTransformer(fn: any, x: any) {
  return x.then ? x.then((r: any) => fn(r)) : fn(x);
}
